import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ConditionsGenerales() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream">
      {/* Header */}
      <header className="bg-white border-b border-navy-100 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-navy-600 hover:text-gold-600 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="font-semibold">Retour</span>
            </button>
            <img
              src="/visinot-logo.png"
              alt="VISINOT"
              className="h-10 w-auto cursor-pointer"
              onClick={() => navigate('/')}
            />
            <div className="w-24" />
          </div>
        </div>
      </header>

      {/* Contenu */}
      <div className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-card p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-display font-bold text-navy-600 mb-2">
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-navy-400 mb-8">Dernière mise à jour : 12/01/2026</p>

          <div className="prose prose-navy max-w-none">
            {/* Section 1 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                1. Informations légales
              </h2>
              <p className="text-navy-500 mb-4">
                Le site www.visinot.be est édité par :
              </p>
              <ul className="list-disc pl-6 text-navy-500 space-y-1">
                <li><strong>Nom :</strong> Alessio Cossu</li>
                <li><strong>Statut :</strong> Personne physique</li>
                <li><strong>Adresse :</strong> Rue Haute Pensée 9/4, 7830 Silly, Belgique</li>
                <li><strong>TVA :</strong> BE1022.114.635</li>
                <li><strong>Email :</strong> contact@visinot.be</li>
                <li><strong>Téléphone :</strong> +32 486 49 46 70</li>
              </ul>
              <p className="text-navy-500 mt-4">Ci-après dénommé « VISINOT ».</p>
            </section>

            {/* Section 2 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                2. Objet du site
              </h2>
              <p className="text-navy-500 mb-4">
                VISINOT est une plateforme permettant aux études notariales de commander des services de visites immobilières, incluant notamment :
              </p>
              <ul className="list-disc pl-6 text-navy-500 space-y-1">
                <li>l'organisation de visites de biens immobiliers ;</li>
                <li>la gestion des rendez-vous et du planning des visites.</li>
              </ul>
              <p className="text-navy-500 mt-4">
                VISINOT agit exclusivement comme prestataire de services et ne participe en aucun cas à la transaction immobilière, à la vente, ni à la relation contractuelle entre le notaire et les tiers.
              </p>
            </section>

            {/* Section 3 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                3. Accès au site et création de compte
              </h2>
              <p className="text-navy-500 mb-4">
                L'accès au site est réservé aux professionnels du notariat.
              </p>
              <p className="text-navy-500 mb-4">
                La création d'un compte utilisateur gratuit est nécessaire pour accéder aux services.
                L'utilisateur s'engage à fournir des informations exactes et à les maintenir à jour.
              </p>
              <p className="text-navy-500">
                VISINOT se réserve le droit de suspendre ou supprimer un compte en cas d'utilisation abusive ou non conforme aux présentes CGU.
              </p>
            </section>

            {/* Section 4 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                4. Description des services
              </h2>
              <p className="text-navy-500 mb-4">
                Les services proposés par VISINOT consistent exclusivement à :
              </p>
              <ul className="list-disc pl-6 text-navy-500 space-y-1">
                <li>organiser des visites de biens immobiliers pour le compte de notaires ;</li>
                <li>planifier et coordonner les rendez-vous avec les visiteurs.</li>
              </ul>
              <p className="text-navy-500 mt-4">
                Les prestations sont proposées sous forme de formules payantes, choisies librement par le client selon ses besoins.
              </p>
            </section>

            {/* Section 5 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                5. Commandes et paiements
              </h2>
              <p className="text-navy-500 mb-4">
                Les services sont payables à la commande, via la plateforme de paiement sécurisée Stripe.
              </p>
              <p className="text-navy-500 mb-4">
                Les prix affichés sont exprimés en euros, hors ou toutes taxes comprises selon indication.
              </p>
              <p className="text-navy-500">
                Toute commande validée et payée est ferme et définitive.
              </p>
            </section>

            {/* Section 6 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                6. Absence de droit de rétractation et de remboursement
              </h2>
              <p className="text-navy-500 mb-4">
                Les services proposés par VISINOT constituent des prestations de services exécutées à une date déterminée.
              </p>
              <p className="text-navy-500">
                Conformément au droit belge, aucun droit de rétractation ni remboursement n'est accordé, sauf obligation légale contraire.
              </p>
            </section>

            {/* Section 7 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                7. Rôle et responsabilité de VISINOT
              </h2>
              <p className="text-navy-500 mb-4">VISINOT :</p>
              <ul className="list-disc pl-6 text-navy-500 space-y-1">
                <li>agit uniquement comme prestataire technique et opérationnel ;</li>
                <li>n'intervient pas dans la transaction immobilière ;</li>
                <li>n'est pas responsable des décisions prises par le notaire ou les visiteurs ;</li>
                <li>n'assume aucune responsabilité quant à la vente, au prix, à l'état du bien ou aux obligations légales liées à la transaction.</li>
              </ul>
              <p className="text-navy-500 mt-4">
                La responsabilité de VISINOT est strictement limitée à la bonne exécution du service commandé.
              </p>
            </section>

            {/* Section 8 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                8. Données personnelles
              </h2>
              <p className="text-navy-500 mb-4">
                VISINOT a uniquement accès aux coordonnées des visiteurs (nom, téléphone, email) dans le but exclusif de :
              </p>
              <ul className="list-disc pl-6 text-navy-500 space-y-1">
                <li>planifier ;</li>
                <li>organiser ;</li>
                <li>gérer les visites.</li>
              </ul>
              <p className="text-navy-500 mt-4">
                Ces données ne sont ni revendues, ni utilisées à des fins commerciales.
              </p>
              <p className="text-navy-500 mt-4">
                Le traitement des données est effectué conformément à la législation belge et au RGPD.
              </p>
            </section>

            {/* Section 9 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                9. Propriété intellectuelle
              </h2>
              <p className="text-navy-500 mb-4">
                L'ensemble du contenu du site (textes, logos, structure, visuels) est la propriété exclusive de VISINOT.
              </p>
              <p className="text-navy-500">
                Toute reproduction ou utilisation non autorisée est strictement interdite.
              </p>
            </section>

            {/* Section 10 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                10. Disponibilité du site
              </h2>
              <p className="text-navy-500 mb-4">
                VISINOT s'efforce d'assurer l'accessibilité du site mais ne garantit pas une disponibilité continue et sans interruption.
              </p>
              <p className="text-navy-500">
                Aucune indemnité ne pourra être réclamée en cas d'indisponibilité temporaire.
              </p>
            </section>

            {/* Section 11 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                11. Modification des CGU
              </h2>
              <p className="text-navy-500 mb-4">
                VISINOT se réserve le droit de modifier les présentes CGU à tout moment.
              </p>
              <p className="text-navy-500">
                Les CGU applicables sont celles en vigueur au moment de l'utilisation du site.
              </p>
            </section>

            {/* Section 12 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-600 mb-4 border-l-4 border-gold-500 pl-4">
                12. Droit applicable et juridiction compétente
              </h2>
              <p className="text-navy-500 mb-4">
                Les présentes CGU sont soumises au droit belge.
              </p>
              <p className="text-navy-500">
                Tout litige relève de la compétence exclusive des tribunaux du ressort du siège de VISINOT.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
